function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrders = function SvgOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M10.514 11.599H4.957m5.557-3.405H4.957m2.12-3.398h-2.12m.11 10.37h5.866c1.653 0 2.993-1.366 2.993-3.05V4.884c0-1.685-1.34-3.052-2.993-3.052H5.067c-1.653 0-2.993 1.367-2.993 3.052v7.23c0 1.685 1.34 3.052 2.993 3.052"
  }));
};
export default SvgOrders;